/**
 * slideoverStore — tiny external store that tracks how many
 * right-side slide-over panels are currently mounted.
 *
 * Any panel that visually occupies the bottom-right corner (Timeline
 * SMS composer, future call transfer picker, etc.) should call
 *   const off = registerSlideover();
 *   return () => off();
 * inside a `useEffect`, and the global Ask Avi FAB reads
 *   const isOpen = useSlideoverOpen();
 * to auto-hide while any panel is open — otherwise the FAB sits on
 * top of the composer Send button and eats clicks.
 *
 * Uses React 18's useSyncExternalStore so subscribers only re-render
 * when the count actually crosses zero.
 */
import { useSyncExternalStore } from "react";

let count = 0;
const listeners = new Set();

function _emit() {
  for (const l of listeners) l();
}

export function registerSlideover() {
  count += 1;
  _emit();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    count = Math.max(0, count - 1);
    _emit();
  };
}

function _subscribe(l) {
  listeners.add(l);
  return () => listeners.delete(l);
}

function _getSnapshot() {
  return count > 0;
}

export function useSlideoverOpen() {
  return useSyncExternalStore(_subscribe, _getSnapshot, () => false);
}
